import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import About from './pages/About';
import StormDemo from './pages/StormDemo';
import WeatherAPI from './pages/WeatherAPI';
import PublicAdjusters from './pages/PublicAdjusters';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/storm-demo" element={<StormDemo />} />
          <Route path="/weather-api" element={<WeatherAPI />} />
          <Route path="/public-adjusters" element={<PublicAdjusters />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;